// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__S0f-d","overlay":"Home_overlay__zAfvI","popup":"Home_popup__KFHOy","topSeparator":"Home_topSeparator__iqe4-","bookNowA":"Home_bookNowA__zBBc1"};